import { X } from "lucide-react";
import { useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
}) {
  const { isDark } = useTheme();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeMap = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}>
      <div
        className={`w-full ${sizeMap[size]} border rounded-2xl shadow-card animate-slide-up flex flex-col max-h-[90vh] ${
          isDark
            ? "bg-gray-900 border-gray-800"
            : "bg-white border-gray-200"
        }`}>
        {/* Header */}
        <div
          className={`flex items-center justify-between px-6 py-4 border-b flex-shrink-0 ${
            isDark ? "border-gray-800" : "border-gray-100"
          }`}>
          <h2
            className={`text-base font-semibold ${
              isDark ? "text-gray-100" : "text-gray-900"
            }`}>
            {title}
          </h2>
          <button
            onClick={onClose}
            className={`p-1.5 rounded-lg transition-colors ${
              isDark
                ? "text-gray-400 hover:text-gray-200 hover:bg-gray-800"
                : "text-gray-400 hover:text-gray-700 hover:bg-gray-100"
            }`}>
            <X size={18} />
          </button>
        </div>
        {/* Body */}
        <div className="overflow-y-auto flex-1 px-6 py-5">{children}</div>
      </div>
    </div>
  );
}
